import React, { useState, useContext, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import GeneralContext from "../GeneralContext/GeneralContext";
import Grid from "@mui/material/Grid2";
import dayjs from "dayjs";
import "dayjs/locale/es";

import Alert from '@mui/material/Alert';
import { esES } from "@mui/x-date-pickers/locales";
import axios from "../../api/axios";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageButtonWhite from "../GeneralComponents/PageButtonWhite";

import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import { CircularProgress } from "@mui/material";

import ModalStandard from "../GeneralComponents/ModalStandard";
import ModalStandardCancel from "../GeneralComponents/ModalStandardCancel";
import BreadcrumbStandard from "../GeneralComponents/BreadcrumbStandard";

import PageError from "../GeneralComponents/PageError";
import { Divider} from '@mui/material';
import ContingenciasHiddenPreview from "./ContingenciasHiddenPreview";
import HourglassLoader from "../GeneralComponents/HourglassLoader";

import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';

import { getValueByKey, toSnakeCase } from "../utils/general_utils";

import {NO_EES, NO_EES_TEMP, NO_SUBTEL, NO_MINEDUC, ROL_REP_EES, ROL_REP_EES_TEMP, ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL, ROL_MINEDUC_ADMIN, DAYS, DEFAULT_ITEMS_CONTINGENCIAS} from "../../Constants/Constants";

let g_start_date = new Date();
g_start_date.setDate(g_start_date.getDate() - 7);

export default function ContingenciasFirma() {
  const { pageTitle, setPageTitle, setDrawerHidding, userSesion, includeRol } =  useContext(GeneralContext);
  
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [documentVisible, setDocumentVisible] = useState(true);

  const [confirmFirma, setConfirmFirma] = useState(false);
  const [confirmRechazo, setConfirmRechazo] = useState(false);
  const [canSign, setCanSign] = useState(false);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  const [modalError, setModalError] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalDetail, setModalDetail] = useState("");

  const [justificacionError, setJustificacionError] = useState(false);
  const justificacionRef = useRef(null);

  const { id } = useParams();
  const links = [
    { name: 'Inicio', path: '/home' },
    { name: 'Listado Justificaciones de Indisponibilidad', path: '/contingencias_lista' },
    { name: 'Firma Justificación de Indisponibilidad', path: '/contingencias_firma/'+id },
  ];

  const [typeContingencia, setTypeContingencia] = useState("");
  const [textContingencia, setTextContingencia] = useState("");


  const [formData, setFormData] = useState({
    name_emisor: userSesion.nombre,
    rut_emisor: userSesion.rut,
    nombre_colegio: "",
    id_operador: "",
    id_zona: "",
    region: "",
    comuna: "",
    operator_name: "",
    rbd: "",
    ees_managers: ["", ""],
    ees_managers_email: ["", ""],
    ees_temporal_manager_list: [""],
    ees_temporal_manager: "",
    ees_temporal_manager_email: "",
    ees_temporal_manager_nombres: "",
    ees_temporal_manager_apellidos: "",
    checked: false,
    contingencia_programada: false,
    programada_descripcion: "",
    programada_inicio_contingencia: dayjs(),
    programada_fin_contingencia: dayjs(),
    programada_hora_inicio: dayjs().hour(0).minute(0),
    programada_hora_termino: dayjs().hour(23).minute(59),
    especifica_fecha_hora_resolucion: dayjs(),
    especifica_fecha_hora_ocurrencia: dayjs(),
    especifica_codigo_evento: "",
    especifica_origen_falla: "",
    especifica_extension_falla: "",
    especifica_descripcion_falla: "",
    days:  DAYS.reduce((acc, dia) => ({ ...acc, [dia]: false }), {}),
    extension : "rbd",
    zonas: {},
  });


  const [action, setAction] = React.useState(null);

  const [msg, setMsg] = React.useState("");
  const [descriptionMsg, setDescriptionMsg] = React.useState("");
  const [btnText, setBtnText] = React.useState("");
  const [openConfirmAction, setOpenConfirmAction] = React.useState(false);

  
  const handleOpenChangeType = (action) => { setAction(action); setMsg(action==="Firmar" ? "¿Esta seguro que quiere firmar esta justificación de indisponibilidad?" : "¿Esta seguro que quiere rechazar esta justificación de indisponibilidad?"); setDescriptionMsg("Esta acción no puede ser revertida."); setBtnText(action==="Firmar" ? "Sí, firmar justificación" : "Sí, rechazar justificación"); setOpenConfirmAction(true)  }
  const handleCloseChangeType = () =>{ setOpenConfirmAction(false); }

  const confirmChangeType = async () => {
    setOpenConfirmAction(false);
    if (action==="Firmar"){
      signDoc();
    } else if (action === "Rechazar") {
      rejectDoc()
    } 
  };

  const validateReject = () => {
  const justificacion = (formData.justificacion_subtel || "").trim();
  const hasError = !justificacion;

  setJustificacionError(hasError);

  if (hasError) {
    justificacionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });

    setTimeout(() => {
      justificacionRef.current?.querySelector("textarea, input")?.focus();
    }, 300);

    return false;
  }

  return true;
};


const fetchData = (query) => {
    setLoading(true);

    axios
        .getContingencia(id)
        .then((response) => {
            const datos = response.data.datos || {};
            const estado = response.data.estado || "";
            const parseTime = (timeString) => {
                if (!timeString) return "";
                const [hours, minutes, seconds] = timeString.split(":").map(Number);
                return dayjs().set("hour", hours).set("minute", minutes).set("second", seconds);
            };

            setFormData({
                ...datos,
                fecha_creacion: response.data.fecha_creacion.replace("T", " "),
                especifica_fecha_hora_ocurrencia: dayjs(datos["especifica_fecha_hora_ocurrencia"] || null),
                especifica_fecha_hora_resolucion: dayjs(datos["especifica_fecha_hora_resolucion"] || null),
                programada_inicio_contingencia: dayjs(datos["programada_inicio_contingencia"] || null),
                programada_fin_contingencia: dayjs(datos["programada_fin_contingencia"] || null),
                estado,
                extension: datos["extension"] || "rbd",
                programada_hora_inicio: parseTime(datos["programada_hora_inicio"]),
                programada_hora_termino: parseTime(datos["programada_hora_termino"]),
                ees_managers_email: datos["ees_managers_email"] ? datos["ees_managers_email"] : ["", ""],
            });
            const cont_tp = response.data.tipo_contingencia;
            setTypeContingencia(cont_tp);
             const es_externa = String(datos?.especifica_origen_falla ?? "")
              .toUpperCase()
              .includes("EXTERNA");
            setTextContingencia(cont_tp==="ESPECIFICA" && !es_externa ? getValueByKey(DEFAULT_ITEMS_CONTINGENCIAS, "id", "3", "description") : getValueByKey(DEFAULT_ITEMS_CONTINGENCIAS, "type", cont_tp, "description"))
         })
        .catch((error) => {
            console.error("Error al obtener los datos:", error);
            setDocumentVisible(false);
        })
        .finally(() => {
            setLoading(false);
        });
};


  function signDoc() {
        if (!confirmFirma) {
        setConfirmFirma(true)
        setConfirmRechazo(false)
        return;
    }
    setLoadingButton(true);

    const form = new FormData();
    const localFormData = {
        ...formData,
        especifica_fecha_hora_ocurrencia: formData["especifica_fecha_hora_ocurrencia"].locale('es').format('YYYY/MM/DD HH:mm:ss').toString(),
        especifica_fecha_hora_resolucion: formData["especifica_fecha_hora_resolucion"].locale('es').format('YYYY/MM/DD HH:mm:ss').toString(),
        programada_inicio_contingencia: formData["programada_inicio_contingencia"].locale('es').format('YYYY/MM/DD').toString(),
        programada_fin_contingencia: formData["programada_fin_contingencia"].locale('es').format('YYYY/MM/DD').toString(),
        programada_hora_inicio: formData["programada_hora_inicio"].locale('es').format('HH:mm:ss').toString(),
        programada_hora_termino: formData["programada_hora_termino"].locale('es').format('HH:mm:ss').toString(),

    }



    form.append("data", JSON.stringify(localFormData));
        axios
      .signDoc("contingencias",id, form)
      .then((response) => {
          setModalError(false);
          setModalContent("Documento enviado y firmado");
          setModalDetail("");
          setOpen(true);
          fetchData("");
      })
      .catch((error) => {
          setModalError(true);
          setModalContent("La firma del documento falló");
          setModalDetail(error?.response?.data?.detail || "");
          setOpen(true);
          fetchData("");
      })
      .finally(() => {
       setLoadingButton(false);
        setConfirmFirma(false);
      });

  }

    function rejectDoc() {
  if (!validateReject()) return;
    if (!confirmRechazo) {
        setConfirmRechazo(true)
        setConfirmFirma(false)
        return;
    }
    setLoadingButton(true);
    const form = new FormData();
    const localFormData = {
        ...formData,
        especifica_fecha_hora_ocurrencia: formData["especifica_fecha_hora_ocurrencia"].locale('es').format('YYYY/MM/DD HH:mm:ss').toString(),
        especifica_fecha_hora_resolucion: formData["especifica_fecha_hora_resolucion"].locale('es').format('YYYY/MM/DD HH:mm:ss').toString(),
        programada_inicio_contingencia: formData["programada_inicio_contingencia"].locale('es').format('YYYY/MM/DD').toString(),
        programada_fin_contingencia: formData["programada_fin_contingencia"].locale('es').format('YYYY/MM/DD').toString(),
        programada_hora_inicio: formData["programada_hora_inicio"].locale('es').format('HH:mm:ss').toString(),
        programada_hora_termino: formData["programada_hora_termino"].locale('es').format('HH:mm:ss').toString(),
    }

    form.append("data", JSON.stringify(localFormData));
    axios
      .rejectDoc("contingencias",id, form)
      .then((response) => {
        navigate("/contingencias_lista");
      })
      .catch((error) => {
        fetchData("");
      })
      .finally(() => {
       setLoadingButton(false);
        setConfirmRechazo(false);
      });
  }



  useEffect(() => {
    setPageTitle("Firma de Justificación de Indisponibilidad");
    fetchData("");
    setDrawerHidding(false);
    setPageLoaded(true);
  }, []);


   useEffect(() => {   
    if (includeRol([ROL_REP_EES,ROL_REP_EES_TEMP]) && (formData.estado === NO_EES || formData.estado === NO_EES_TEMP)  ){
      setCanSign(true);
    }else if (includeRol([ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL]) && formData.estado === NO_SUBTEL){
      setCanSign(true);
    }else if(includeRol([ROL_MINEDUC_ADMIN]) && formData.estado === NO_MINEDUC){
      setCanSign(true);
    }else{
      setCanSign(false);
    }
  }, [userSesion, formData]);

  if (pageLoaded) {
    return (
        <Box test_state={formData.estado}  test_data={id} >
          <PageBody >
          <BreadcrumbStandard links={links} />
        {loading ? (
        <PageBgBlock pad="2rem 9rem">
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "50vh",
                width: "100%",
                backgroundColor: "white",
              }}
            >
              <CircularProgress />
              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Cargando...
              </Typography>
            </Box>
        </PageBgBlock>

        ) :  loadingButton ? (<HourglassLoader/> ) :
      (documentVisible && canSign ? 


      <>
      <PageBgBlock pad="0" >
      <Box sx={{ paddingLeft: "9rem", paddingRight: "9rem", paddingTop: "2rem"}}> 
       <ContingenciasHiddenPreview formData={formData} id={id} 
              textContingencia={textContingencia}
              typeContingencia={typeContingencia}>
            <>
              {includeRol([ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL, ROL_MINEDUC_ADMIN, ROL_REP_EES, ROL_REP_EES_TEMP]) ? (
                <>

              <Divider sx={{ my: 2 }} />

                    <Typography variant="h3" color="inherit" noWrap sx={{}}>
                      JUSTIFICACIÓN DE RESOLUCIÓN
                    </Typography>

                    <FormControl
                        ref={justificacionRef}
                        sx={{ m: 1, width: "100%", spacing: 2 }}
                      >
                        <TextField
                          test_id={toSnakeCase("justificacion_subtel")}
                          multiline
                          minRows={4}
                          maxRows={30}
                          id="outlined-required"
                          placeholder="Texto aquí"
                          size="small"
                          value={formData.justificacion_subtel}
                          error={justificacionError}
                          helperText={
                            justificacionError
                              ? "Debe completar la justificación de resolución para rechazar la justificación de indisponibilidad."
                              : ""
                          }
                          onChange={(event) => {
                            const value = event.target.value;
                            setFormData({
                              ...formData,
                              justificacion_subtel: value,
                            });

                            if (value.trim()) {
                              setJustificacionError(false);
                            }
                          }}
                        />
                      </FormControl>
                    </>
                ) : null}


        
          <Stack sx={{paddingBottom: "3rem" }}>
                    <Grid container spacing={2} sx={{paddingTop: '2rem'}}>

             {confirmFirma || confirmRechazo ?
                <Grid display="flex" justifyContent="center" alignItems="center" size={12} sx={{paddingBottom: "3rem"}}>
                    <Alert icon={false} variant="filled" severity="warning" sx={{ display: "flex", justifyContent: "center", '& .MuiAlert-message': { textAlign: "center", width: "inherit" } }}>
                        <Typography
                            variant="body"
                            color="inherit"
                            sx={{ textAlign: "center" }}
                        >
                            {confirmRechazo
                              ? "Revise que todos los campos contienen la información correcta antes de rechazar la Justificación de Indisponibilidad. Al hacer clic en 'Rechazar', el documento quedará rechazado sin opción de modificación."
                              : "Revise que todos los campos contienen la información correcta antes de firmar la Justificación de Indisponibilidad. Al hacer clic en 'Aprobar y enviar', el documento quedará firmado sin opción de modificación."}
                        </Typography>
                    </Alert>
                </Grid>
                :
                ""
            }       
            <Grid size={2}></Grid>
            <Grid size={4}>
             <PageButtonWhite
                onClick={() => {
                  if (!validateReject()) return;

                  if (includeRol([ROL_REP_EES, ROL_REP_EES_TEMP]) && confirmRechazo) {
                    handleOpenChangeType("Rechazar");
                  } else {
                    rejectDoc();
                  }
                }}
                loading={loadingButton || confirmFirma}
                width="12rem"
              >
                Rechazar
              </PageButtonWhite>
            </Grid>
            <Grid size={4}>
              <PageButtonBlack onClick={() => {
    if (includeRol([ROL_REP_EES, ROL_REP_EES_TEMP]) && confirmFirma) {
      handleOpenChangeType("Firmar");
    } else {
      signDoc();
    }
  }} loading={loadingButton || confirmRechazo} justifyContent="center" width="12rem">
                Aprobar y enviar
              </PageButtonBlack>
            </Grid>
            <Grid size={2}></Grid>
          </Grid>
          </Stack>

          </>
          </ContingenciasHiddenPreview>

          </Box>
      </PageBgBlock>
      </>
       :

        <PageError >
                El documento al que intenta acceder no esta disponible para ser firmado.
              </PageError>
      
    )}
    <ModalStandard open={open} error={modalError} title={modalContent} msg={modalDetail} btnText={modalError ? "Cerrar" : "Volver a listado"} onClick={modalError ? handleClose : () => navigate("/contingencias_lista")} onClose={modalError ? handleClose : () => navigate("/contingencias_lista")}></ModalStandard>
      

      <ModalStandardCancel
        open={openConfirmAction}
        error={action==="Firmar" ? false : true}
        title="Confirmar acción"
        qst={msg}
        msg={descriptionMsg}
        btnText={btnText}
        onClick={confirmChangeType}
        onClose={handleCloseChangeType}
      />




    </PageBody>
              </Box>
    );
  }
}
